import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-arrow-down",
  "use": "icon-s-arrow-down-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-arrow-down\"><path fill-rule=\"evenodd\" d=\"M18.9997195 14.0277661 10.9907446 21.9997195 3.00028047 14.0277661 4.33922311 12.7073342 10.0713785 18.4364044 10.0713785-.000280465573 11.9131959.03674099 11.9131959 18.4364044 17.6607769 12.7073342z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol